import React from 'react';
import { DatePicker } from 'antd';

import moment from 'moment';
const DateTimePicker = ({ onChange = () => {}, defaultValue = null, minMinutesFromNow = null }) => {
  const disabledTime = (current) => {
    if (!minMinutesFromNow) return {};

    if (current && current?.isSame(moment(), 'day')) {
      const minTime = moment()?.add(minMinutesFromNow, 'minutes');
      return {
        disabledHours: () => {
          const hours = [];
          for (let i = 0; i < minTime?.hour(); i++) {
            hours?.push(i);
          }
          return hours;
        },
        disabledMinutes: (selectedHour) => {
          const minutes = [];
          if (selectedHour === minTime?.hour()) {
            for (let i = 0; i < minTime?.minute(); i++) {
              minutes?.push(i);
            }
          }
          return minutes;
        },
        disabledSeconds: (selectedHour, selectedMinute) => {
          const seconds = [];
          if (selectedHour === minTime?.hour() && selectedMinute === minTime?.minute()) {
            for (let i = 0; i < minTime?.second(); i++) {
              seconds?.push(i);
            }
          }
          return seconds;
        },
      };
    }
    return {};
  };

  return (
    <div className='dateRange'>
      <DatePicker
        className='datePicker'
        defaultValue={defaultValue}
        onChange={onChange}
        // value={value}
        showTime={{ format: 'HH:mm:ss' }}
        format='YYYY-MM-DD HH:mm:ss'
        disabledDate={(current) => current && current?.isBefore(moment(), 'day')}
        disabledTime={minMinutesFromNow ? disabledTime : undefined}
      />
    </div>
  );
};

export default DateTimePicker;
